<template>
  <div class="team-group-detail">
    <div class="view-title">
      <span>{{this.$route.query.name}}</span>
    </div>
    <div class="team-group-detail-wrapper">
      <!--操作头部-->
      <div class="add-ssk">
        <router-link :to="{name: 'team', query: {type: 'group'}}" style="margin-right:6px;">
          <el-button type="text">
            <i class="fa fa-arrow-left fa-lg"></i>
            <translate>Back</translate>
          </el-button>
        </router-link>
        <el-button type="text" @click.stop="onShowTeamGroupAddMember(detail.list)">
          <i class="fa fa-plus fa-lg"></i>
          <translate>Add Member</translate>
        </el-button>
        <el-button type="text" @click="batchDel(detail.batchDel)" :disabled="detail.batchDel === ''">
          <i class="fa fa-trash fa-lg"></i>
          <translate>Remove</translate>
        </el-button>
        <div class="pull-right">
          <el-form :inline="true" class="demo-form-inline">
            <el-select v-model="search.user" class="condition-search">
              <el-option :label="attrText.name" value="q_name"></el-option>
              <el-option :label="attrText.account" value="q_account"></el-option>
            </el-select>
            <el-input v-model.trim="search.val" class="searchInput" icon="search"
                      :disabled="search.user === ''"
                      :on-icon-click="onSearch"
                      @keyup.enter.native="onSearch()">
            </el-input>
          </el-form>
        </div>
      </div>
      <!-- table -->
      <el-table v-loading="loading" :data="detail.list" style="width: 100%" :row-class-name="tableRowClassName"
                @selection-change="onSelectionChange">
        <el-table-column type="selection" width="32"></el-table-column>
        <el-table-column :label="attrText.name" prop="name"></el-table-column>
        <el-table-column :label="attrText.account" prop="account"></el-table-column>
        <el-table-column :label="attrText.role">
          <template scope="scope">
            <div class="log-list-name">
              <p>{{scope.row.is_admin ? attrText.administrator : attrText.ordinary}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="attrText.action" width="180">
          <template scope="scope">
            <el-button type="text" @click="batchDel([scope.row.id])">
              <translate>Remove</translate>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="detail.totalPage > 10">
        <el-pagination layout="total, prev, pager, next" :total="detail.totalPage" :current-page.sync="detail.currentPage"
                        :page-size="10" @current-change="onChangePage"></el-pagination>
      </div>
    </div>

    <component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel"
               @callback="callback"></component>

  </div>
</template>

<script>
  import STORE_CONST from '../../store/consts'
  import TeamGroupAddMember from './model/team-group-add-member'
  export default{
    data () {
      return {
        loading: false,
        detail: {
          totalPage: 1,
          currentPage: 1,
          batchDel: '',
          list: []
        },
        search: {
          user: '',
          val: ''
        },
        currentRightPanel: null,
        rightPanelData: null
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    created () {
      this.getTeamGroupMembers()
    },
    methods: {
      // 提取翻译文本
      getTranslateText () {
        return {
          'name': this.$gettext('Name'),
          'email': this.$gettext('Email'),
          'type': this.$gettext('Type'),
          'role': this.$gettext('Role'),
          'action': this.$gettext('Action'),
          'administrator': this.$gettext('administrator'),
          'ordinary': this.$gettext('Ordinary Member'),
          'account': this.$gettext('Account')
        }
      },
      // 获取群组成员列表
      getTeamGroupMembers (page, total) {
        this.detail.currentPage = page || 1
        let params = {
          id: this.$route.params.id,
          data: {
            page: page || 1
          }
        }
        if (total) { params.data.total = total }
        if (this.search.val !== '') {
          params.data[this.search.user] = this.search.val
        }
        this.loading = true
        this.$store.dispatch(STORE_CONST.TEAM.GET_GROUP_MEMBERS, params).then(res => {
          this.loading = false
          this.detail = Object.assign({}, {
            list: res.objects,
            totalPage: res.total,
            currentPage: page || res.page,
            batchDel: ''
          })
        }, () => {
          this.loading = false
        })
      },
      // 移除群组成员
      batchDel (id) {
        this.$confirm(this.$gettext('Are you sure to remove selected?'), this.$gettext('Remove Confirm'), {
          confirmButtonText: this.$gettext('Ok'),
          cancelButtonText: this.$gettext('Cancel'),
          type: 'warning'
        }).then(() => {
          let params = {
            group_id: this.$route.params.id,
            data: {
              members: id
            }
          }
          this.$store.dispatch(STORE_CONST.TEAM.DEL_GROUP_MEMBER, params).then(() => {
            this.$notify({
              type: 'success',
              message: this.$gettext('Remove successfully!')
            })
            this.clearSearchText()
            this.getTeamGroupMembers()
          })
        })
      },
      // 批量移除群组成员
      onSelectionChange (select) {
        if (select.length !== 0) {
          this.detail.batchDel = select.map(item => item.id)
        } else {
          this.detail.batchDel = ''
        }
        console.log('del', this.detail.batchDel)
      },
      // 清空搜索框
      clearSearchText () {
        this.search.val = ''
      },
      // 搜索
      onSearch () {
        this.getTeamGroupMembers()
      },
      // 分页
      onChangePage (page) {
        this.detail.currentPage = page
        this.getTeamGroupMembers(page, this.detail.totalPage)
      },
      // 关闭侧滑回调
      onClosePanel () {
        this.currentRightPanel = null
        this.rightPanelData = null
      },
      // 传给侧滑的回调函数
      callback () {
        this.clearSearchText()
        return this.getTeamGroupMembers()
      },
      // 显示添加成员
      onShowTeamGroupAddMember (row) {
        const time = !this.currentRightPanel || this.currentRightPanel.name === 'TeamGroupAddMember' ? 0 : 300
        this.currentRightPanel = TeamGroupAddMember
        this.$nextTick(() => {
          setTimeout(() => {
            this.rightPanelData = row || []
          }, time)
        })
      },
      // 更改表格类名
      tableRowClassName (row, index) {
        if (index % 2 === 0) {
          return 'info-row'
        }
        return ''
      }
    },
    components: {
      TeamGroupAddMember
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import "../../assets/css/variable";

  .team-group-detail {
    .team-group-detail-wrapper {
      padding: 15px;
    }
  }

  .add-ssk {
    height: 60px;
    line-height: 60px;
    padding: 0 15px;
    background-color: #fff;
    border: 1px solid $border-color;
    border-bottom: none;
    .el-button--text {
      color: $textColor;
      &:hover {
        color: $mainColor;
      }
      &.is-disabled {
        color: $textColor;
      }
    }
    .pull-right {
      .condition-search {
        width: 100px;
      }
      .searchInput {
        width: 180px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// team-group-detail.vue?5c1766d4